import { Select } from "components/ui/select/Select"
import { formatDate } from "helpers/utils.helper"
import { useGetSeries } from "hooks/api/series/series.hook"
import type { TErefWithFurniture } from "types/elevationReferences.type"
import type { TErefConfigurationSavePayload, TErefConfigOptimisticPatch } from "../../useErefConfigurationSave"
import style from "./SeriesAndDelivery.module.scss"

const { seriesAndDelivery, label } = style

type Props = {
	eref: TErefWithFurniture
	save: (payload: TErefConfigurationSavePayload, optimistic?: TErefConfigOptimisticPatch) => void
	isPending: boolean
	deliveryDates: { id: number; date: string }[]
}

export const SeriesAndDelivery = ({ eref, save, isPending, deliveryDates }: Props) => {
	const { data: series } = useGetSeries()
	const config = eref.estimation_config

	const seriesOptions = series?.map((s) => ({
		label: s.series_name,
		value: s.id,
	}))

	const deliveryDateOptions = deliveryDates.map((d) => ({
		label: formatDate(d.date, "yyyy-MM-dd", "dd MMM, yyyy"),
		value: d.id,
	}))

	return (
		<div className={seriesAndDelivery}>
			<div>
				<span className={label}>Series</span>
				<Select
					variant="outlined"
					placeholder="Select series"
					options={seriesOptions ?? []}
					value={config?.series_override_id ?? null}
					onChange={(v) => save({ series_override_id: (v as number | undefined) ?? null })}
					disabled={isPending}
					allowClear={config?.series_override_id == null}
					renderInPlace
				/>
			</div>
			<div>
				<span className={label}>Delivery date</span>
				<Select
					variant="outlined"
					placeholder="Select delivery date"
					options={deliveryDateOptions}
					value={config?.delivery_date?.id ?? null}
					onChange={(v) => {
						const id = (v as number | undefined) ?? null
						const selected = id == null ? null : (deliveryDates.find((d) => d.id === id) ?? null)
						save({ delivery_date_id: id }, { delivery_date: selected })
					}}
					disabled={isPending}
					allowClear={config?.delivery_date == null}
					renderInPlace
				/>
			</div>
		</div>
	)
}
